import React, {Component} from 'react';
import {connect} from 'react-redux';
import LoadingModal from '../components/LoadingModal/LoadingModal';

class LoadingModalContainer extends Component {
  render() {
    const {isLoading} = this.props;

    if (!isLoading) {
      return null;
    }

    return (
      <LoadingModal />
    );
  }
}

export default connect(
  ({nest}) => ({
    isLoading: nest.isLoading
  }),
  () => ({})
)(LoadingModalContainer);



// WEBPACK FOOTER //
// ./src/app/nest/containers/LoadingModalContainer.js